import { Outlet } from "react-router-dom";
import React, { useState } from "react";

function Clients() {
  const [client, setClient] = useState({});
  const [isEdit, setIsEdit] = useState({
    disabled: false,
    edit: false,
  });
  return <Outlet context={{ client, setClient, setIsEdit, isEdit }} />;
}

export default Clients;
